const USPStrip = ({ items }) => (
  <div className="overflow-hidden bg-[#D99B26] py-3 border-y border-[#0F2F24]/15" data-testid="usp-strip">
    <div className="marquee-track flex w-max items-center gap-10">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.12em] text-[#0F2F24] whitespace-nowrap" data-testid={`usp-strip-item`}>
            {item}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-[#0F2F24] shrink-0" />
        </span>
      ))}
    </div>
  </div>
);

export default USPStrip;
